
export const CONFIRMATION_MODAL = "CONFIRMATION_MODAL";

export const confirmationHandler = (data) => {
  return {
    type: CONFIRMATION_MODAL,
    payload: data,
  };
};


const initialState = {
  loading: false,
  data: null,
  open: false,
  handler: null
};

const dummyHandler = () => {
}
export const confirmationReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONFIRMATION_MODAL:
      return {
        ...state,
        error: action.payload?.open,
        open: action.payload?.open,
        data: action.payload.data,
        handler: action.payload.handler ?? dummyHandler
      };

    default:
      return {...state};
  }
};
